import React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';

const Container = styled.div<{backgroundColor?: string}>(({backgroundColor}) => `
  ${backgroundColor && `
    background-color: ${backgroundColor};
  `}
`);

interface BlockProps {
  backgroundColour?: string;
  className?: string;
  noSpacing?: boolean;
}

export const Block: React.FC<BlockProps> = ({ children, backgroundColour, className, noSpacing }) => {
  const containerClassname = classnames({
    'py-16 md:py-20 px-8' : !noSpacing,
    'border-b border-stone' : true,
  }, className);

  return (
    <Container
      backgroundColor={backgroundColour}
      className={containerClassname}
    >
      {children}
    </Container>
  );
};
